/**
 * Created by brianschroer on 12/16/15.
 */
(function () {
    "use strict";

    // @ngInject
    function CalendlyAddApiKeyModalControllerCtor($modalInstance, $window, $log, $q, $scope, $injector, _,
                                            UsersManager, UserService, AnalyticsService, PopupMessageService, $timeout) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CalendlyAddApiKeyModalController';
        AnalyticsService.trackPageView(this, 'CalendlyAddApiKeyModalView');

        this.$modalInstance = $modalInstance;
        this.$log = $log;
        this.$window = $window;
        this._ = _;
        this.$q = $q;
        this.$timeout = $timeout;
        this.AnalyticsService = AnalyticsService;

        this.UsersManager = UsersManager;
        this.UserService = UserService;
        this.PopupMessageService = PopupMessageService;
        this.user = this.UsersManager.getCurrUser();
        this.showError = false;
        this.submittingLoader = false;

    }

    Controllers.CalendlyAddApiKeyModalController = Class(Controllers.BaseController, {

        constructor: CalendlyAddApiKeyModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        cancel: function cancel() {
            this.$modalInstance.dismiss();
        },

        connectCalendlyApiKey: function connectCalendlyApiKey() {
            if (!this.apiKey) {
                return;
            }
            this.submittingLoader = true;
            this.errorMessage = null;

            this.UsersManager.setCalendlyApiKey(this.user, this.apiKey)
                .then(function success(resp) {
                        this.success = true;
                        this.UsersManager.forceFetchCurrUser();
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.calendly_successful_connection);
                        this.$timeout(function () {
                            this.close();
                        }.bind(this), 2000);
                    }.bind(this),
                    function fail(resp) {
                        this.errorMessage = resp.data.error_message;
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.calendly_error_connection, resp);
                    }.bind(this))
                .finally(function () {
                    this.submittingLoader = false;
                }.bind(this));
        }
    });
}());
